import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchContent } from 'actions/content';
import renderItemThumbnail from 'screens/AssetPickerModal/renderItemThumbnail';
import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import isMultiDomain from 'utils/isMultiDomain';
import DistributedContentIcon from 'components/DistributedContentIcon';
function PlaylistPickerModal(_ref) {
  var isDisabled = _ref.isDisabled,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    defaultSelectedItems = _ref.defaultSelectedItems,
    defaultIndeterminateItems = _ref.defaultIndeterminateItems,
    filterItems = _ref.filterItems,
    audience = _ref.audience,
    privilege = _ref.privilege,
    teamIds = _ref.teamIds,
    disabledItems = _ref.disabledItems,
    onBeforeChange = _ref.onBeforeChange,
    parentPlaylistId = _ref.parentPlaylistId,
    getFullData = _ref.getFullData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var labels = {
    getSelectionStatus: function getSelectionStatus(count) {
      return t('playlist_selection_status', {
        count: count
      });
    }
  };

  // Create request hook
  var _useFetchContent = useFetchContent({
      type: 'playlist',
      audience: audience,
      teamIds: teamIds,
      search: searchValue,
      privilege: privilege,
      playlistIdForCircularReferenceCheck: parentPlaylistId && +parentPlaylistId,
      getFullData: getFullData
    }),
    items = _useFetchContent.items,
    hasNextPage = _useFetchContent.hasNextPage,
    fetchNextPage = _useFetchContent.fetchNextPage,
    isError = _useFetchContent.isError,
    isLoading = _useFetchContent.isLoading,
    isFetchingNextPage = _useFetchContent.isFetchingNextPage;

  // Run items through filterItems
  var filteredItems = filterItems ? items.filter(filterItems) : items;
  var distributedIcon = function distributedIcon(item) {
    return isMultiDomain(item) && /*#__PURE__*/React.createElement(DistributedContentIcon, {
      type: item.type
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    id: "playlist-picker-modal",
    "aria-label": t('actions_select_playlists'),
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(ItemPicker, {
    isDisabled: isDisabled,
    disabledItems: disabledItems,
    title: t('actions_select_playlists'),
    labels: labels,
    defaultSelectedItems: defaultSelectedItems,
    defaultIndeterminateItems: defaultIndeterminateItems,
    onSearchValueChange: setSearchValue,
    renderItemIcon: renderItemThumbnail,
    renderInlineIcon: distributedIcon,
    onSubmit: onSubmit,
    onClose: onClose,
    items: filteredItems,
    hasNextPage: hasNextPage,
    onFetchNextPage: fetchNextPage,
    isFetchingNextPage: isFetchingNextPage,
    isError: isError,
    isLoading: isLoading,
    onBeforeChange: onBeforeChange
  }));
}
export default PlaylistPickerModal;